export enum SubscriptionPlanCodeEnum {
  BASIC = 'basic',
  BASIC_YEARLY = 'basic_yearly',
  PRO = 'pro',
  PRO_YEARLY = 'pro_yearly',
}

export enum BillingPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export interface PlanFeature {
  key?: 'included_users' | 'extra_users' | string;
  text: string;
  included: boolean;
}

export interface Plan {
  id: string;
  name: string;
  nameAr: string;
  description: string;
  descriptionAr: string;
  monthlyPrice: number;
  yearlyPrice: number;
  monthlyPlanCode: SubscriptionPlanCodeEnum;
  yearlyPlanCode: SubscriptionPlanCodeEnum;
  currency: string;
  features: PlanFeature[];
  recommended?: boolean;
  planKey: number;
  includedUsersLimit?: number;
  monthlyExtraUserPrice?: number;
  yearlyExtraUserPrice?: number;
}

export const PLANS: Plan[] = [
  {
    id: 'basic',
    name: 'Basic',
    nameAr: 'الباقة الأساسية',
    description: 'For personal use',
    descriptionAr: 'للاستخدام الشخصي',
    monthlyPrice: 49,
    yearlyPrice: 468,
    monthlyPlanCode: SubscriptionPlanCodeEnum.BASIC,
    yearlyPlanCode: SubscriptionPlanCodeEnum.BASIC_YEARLY,
    currency: 'ريال',
    planKey: 1,
    features: [
      { text: 'اجتماعات غير محدودة', included: true },
      { text: 'اجتماعات فردية (One-to-One)', included: true },
      { text: 'الربط مع تقويم قوقل', included: true },
      { text: 'إنشاء روابط اجتماعات Google Meet تلقائية', included: true },
      { text: 'أتمتة التذكيرات والمتابعة (Workflows)', included: true },
      { text: 'تحليلات وتقارير أداء الاجتماعات', included: true },
      { text: 'الربط مع أنظمة إدارة العملاء (CRM)', included: true },
      { text: 'الربط مع أدوات التحليلات والتتبع', included: true },
      { text: 'اجتماعات جماعية (One-to-Group)', included: true },
      { text: 'تضمين أداة الحجز داخل موقعك الإلكتروني', included: true },
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    nameAr: 'الباقة الاحترافية',
    description: 'For professionals and organizations',
    descriptionAr: 'للمحترفين والمنظمات',
    monthlyPrice: 89,
    yearlyPrice: 828,
    monthlyPlanCode: SubscriptionPlanCodeEnum.PRO,
    yearlyPlanCode: SubscriptionPlanCodeEnum.PRO_YEARLY,
    currency: 'ريال',
    planKey: 3,
    recommended: true,
    features: [
      { text: 'استقبال المدفوعات (مدى، أبل باي)', included: true },
      { text: 'التوزيع التلقائي للمواعيد (Round Robin)', included: true },
      { text: 'اجتماعات الفريق المشترك (Collective)', included: true },
      { text: 'إرسال التذكيرات من بريدك الخاص', included: true },
      { text: 'نماذج التأهيل وتوجيه المدعوين تلقائياً', included: true },
      { text: 'نطاق مخصص (Custom Domain)', included: true },
      { text: 'استطلاعات أوقات الاجتماعات (Meeting Polls)', included: true },
      { text: 'روابط الاستخدام لمرة واحدة', included: true },
    ],
  },
];

export const PLAN_VALUES: Record<string, number> = {
  basic: 1,
  pro: 3,
};

export const BASIC_PLAN_VALUES = [1, 2];
export const PRO_PLAN_VALUES = [3, 4];

export const isBasicPlanValue = (planValue: number): boolean =>
  BASIC_PLAN_VALUES.includes(planValue);

export const isProPlanValue = (planValue: number): boolean =>
  PRO_PLAN_VALUES.includes(planValue);

export const normalizeBasePlanValue = (planValue: number): number => {
  if (planValue === 2) return 1;
  if (planValue === 4) return 3;
  return planValue;
};
